import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'core/store';
import {
  IonButton,
  IonContent,
  IonIcon,
  IonPage,
  IonText,
  IonToolbar
} from '@ionic/react';
import Close from 'assets/icons/close.svg';
import { fetchProductDetails } from 'features/shared/inventory/store/InventoryActions';
import { hideSelectionDetailsModal } from 'features/shared/inventory/store/InventorySlice';
import InventoryDetailSkeletonLoader from 'features/shared/inventory/components/InventoryDetailSkeletonLoader';
import './HomeSelectionDetailsMobile.scss';

const na = (val?: string | null) =>
  val && val.trim() !== '' ? val.trim() : 'N/A';

const HomeSelectionDetailsMobile: React.FC = () => {
  const dispatch = useDispatch();
  const homeId = useSelector((state: RootState) => state.home.currentHome?.id);
  const { product_id, product, productDetailsLoading } = useSelector(
    (state: RootState) => state.inventory
  );

  useEffect(() => {
    if (!homeId || !product_id) {
      return;
    }
    dispatch(fetchProductDetails(homeId, product_id));
  }, [dispatch, homeId, product_id]);

  const attributes = useMemo(() => {
    if (!product) {
      return [];
    }
    const mfr = product.product_template.manufacturer;
    const typeDataLabel = product.product_template.type_data?.label;
    const category =
      typeDataLabel != null && String(typeDataLabel).trim() !== ''
        ? String(typeDataLabel).trim()
        : product.product_template.type;

    return [
      { label: 'Description', value: na(product.product_template.description) },
      { label: 'Category', value: na(category) },
      { label: 'Brand/Manufacturer', value: na(mfr?.name) },
      { label: 'Option Code', value: na(product.serial) }
    ];
  }, [product]);

  const close = () => dispatch(hideSelectionDetailsModal());

  return (
    <IonPage className="hk-mobile-selection-details-page">
      <IonButton
        className="hk-mobile-selection-details-close-btn"
        fill="clear"
        shape="round"
        onClick={close}
      >
        <IonIcon icon={Close} />
      </IonButton>
      {productDetailsLoading ? (
        <IonContent className="hk-mobile-selection-details-content">
          <InventoryDetailSkeletonLoader showImage={false} />
        </IonContent>
      ) : (
        <>
          <IonContent className="hk-mobile-selection-details-content">
            {!product ? (
              <div className="hk-mobile-selection-details-empty">
                <IonText color="medium">Item not found.</IonText>
              </div>
            ) : (
              <div className="hk-mobile-selection-details-body">
                <div className="hk-mobile-selection-details-section-header">
                  <span className="hk-mobile-selection-details-section-title">
                    Option Details
                  </span>
                </div>
                <div className="hk-mobile-selection-details-fields">
                  {attributes.map((attr, i) => (
                    <div
                      key={`attr-${i}`}
                      className="hk-mobile-selection-details-field"
                    >
                      <span className="hk-mobile-selection-details-field-label">
                        {attr.label}
                      </span>
                      <div className="hk-mobile-selection-details-field-value">
                        <span>{attr.value}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </IonContent>
          <IonToolbar className="hk-mobile-selection-details-footer">
            <IonButton
              expand="block"
              color="primary"
              strong={true}
              onClick={close}
            >
              Done
            </IonButton>
          </IonToolbar>
        </>
      )}
    </IonPage>
  );
};

export default HomeSelectionDetailsMobile;
